import { inject, Injectable, isSignal, resource, ResourceRef, Signal } from '@angular/core';
import { ENVIRONMENT } from '@sona/angular-util-environment';
import { AddonName, PurchasableAddonName } from '@sona/shared-model-common';
import { firstValueFrom } from 'rxjs';

import { PaymentsApi } from './payments-api';

import type Stripe from 'stripe';

@Injectable({
    providedIn: 'root'
})
export class PaymentsFacade {

    private readonly _api = inject(PaymentsApi);
    private readonly _environment = inject(ENVIRONMENT);

    getCustomerSession(): ResourceRef<Stripe.CustomerSession> {
        return resource({
            loader: () => firstValueFrom(this._api.createCustomerSession())
        });
    }

    async openCheckout(addonName: AddonName): Promise<void> {
        const { url } = await firstValueFrom(this._api.createCheckoutSession(addonName, window.location.href));

        window.location.href = url;
    }

    async openBillingPortal() {
        const { url } = await firstValueFrom(this._api.createBillingPortalSession());

        window.open(url, '_blank');
    }

    getPaymentDetails(sessionId: Signal<string | null | undefined>) {
        return resource({
            request: () => ({ sessionId: sessionId() }),
            loader: ({ request }) => firstValueFrom(this._api.getPaymentDetails(request.sessionId))
        });
    }

    getPrice(addonName: AddonName | Signal<AddonName | null | undefined>) {
        return resource({
            request: () => ({ addonName: isSignal(addonName) ? addonName() : addonName }),
            loader: ({ request }) => firstValueFrom(this._api.getPrice(request.addonName))
        });
    }

    async endTrial() {
        await firstValueFrom(this._api.endTrial());
    }
}
